<dhofar-shared-footer></dhofar-shared-footer>
